var CpsRegForm = window.CpsRegForm = (function() {
    return {
        termsPopup: (function () {
            const selectors = {
                popup: '#terms-popup',
                container: '#terms-popup__container',
                showButton: '#term-of-use-link',
                closeButton: '.js-terms-popup-close',
                textContainer: '#terms-popup__text',
                header: '#terms-popup__header',
                footer: '#terms-popup__footer'
            }

            function installFieldMasks() {
                $('.restore-password-phone').inputmask('+7 (999) 999-99-99');
                $('#SmsCode').inputmask('999999');
            }

            function bindUI() {
                const body = $('body');

                body.on('click', selectors.showButton, show);
                body.on('click', selectors.closeButton, hide);

                body.on('click', selectors.popup, function (e) {
                    if (e.target.getAttribute('id') === selectors.popup.slice(1))
                        hide();
                });

                $(window).on('resize', function () {
                    resize();
                });

                validatePromo($('#PromoCodeNumber')[0]);

                $(document).on('paste change keyup input', '#PromoCodeNumber', function (event) {
                    handlepromoInput($(this)[0]);
                });
            }

            function validatePromo(element: HTMLElement) {
                var changeButtonItem = $('.j-promo-activate');

                if (!!$(element).val()) {
                    changeButtonItem.removeClass('m-disabled');
                }
                else {
                    changeButtonItem.addClass('m-disabled');
                }
            }

            function handlepromoInput(element: HTMLElement) {
                validatePromo(element);
            }

            function resize() {
                let newHeight = $(window).height() - ($(selectors.header).outerHeight() + $(selectors.footer).outerHeight() + 40);

                $(selectors.textContainer).css({
                    height: newHeight
                });

                let container = $(selectors.container),
                    containerHeight = $(selectors.container).outerHeight(),
                    containerWidth = $(selectors.container).outerWidth();

                container.css({
                    'margin-top': - containerHeight / 2,
                    'margin-left': - containerWidth / 2,
                });
            }

            function show() {
                $(selectors.popup).addClass('visible');
                resize();
            }

            function hide() {
                $(selectors.popup).removeClass('visible');
            }

            function init() {
                bindUI();
            }

            function dispose() {
            }

            return {
                installFieldMasks,
                bindUI,
                init,
                dispose
            }
        }())
    }
}());

/** INIT ON DOM LOAD **/
$(function () {
    CpsRegForm.termsPopup.init();
});